var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36.558 34.884c0 1.356-.54 2.658-1.498 3.618A5.13 5.13 0 0 1 31.443 40H9.116a5.13 5.13 0 0 1-3.618-1.498A5.13 5.13 0 0 1 4 34.884V5.116c0-1.356.54-2.658 1.498-3.618A5.13 5.13 0 0 1 9.116 0H25.09c.863 0 1.691.342 2.302.954l8.212 8.213c.612.61.954 1.438.954 2.3zm-2.79 0V11.468a.47.47 0 0 0-.136-.33L25.42 2.928a.47.47 0 0 0-.33-.136H9.116a2.33 2.33 0 0 0-1.644.68 2.33 2.33 0 0 0-.681 1.645v29.768c0 .617.245 1.207.68 1.644a2.33 2.33 0 0 0 1.645.681h22.326a2.33 2.33 0 0 0 1.645-.68 2.33 2.33 0 0 0 .68-1.645",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24.465 2.326a1.396 1.396 0 0 1 2.79 0v6.512c0 .256.21.465.466.465h6.512a1.396 1.396 0 0 1 0 2.79H27.72a3.255 3.255 0 0 1-3.256-3.255zM12.837 18.605a1.396 1.396 0 0 1 0-2.79h14.884a1.396 1.396 0 0 1 0 2.79zM12.837 25.116a1.396 1.396 0 0 1 0-2.79h14.884a1.396 1.396 0 0 1 0 2.79zM12.837 31.628a1.396 1.396 0 0 1 0-2.791h8.372a1.396 1.396 0 0 1 0 2.79z",
    clipRule: "evenodd"
  })));
};
export default SvgDocument;